const categoryType = {
  SPONSOR: 0,
  AGENDA: 1,
  SPEAKER: 2
};

export { categoryType };
